import { Component, OnInit } from '@angular/core';
import { ClientesService } from 'src/app/services/clientes.service';
import { environment } from '../../../environments/environment';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ProductosService } from 'src/app/services/productos.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-elegir-paquete',
  templateUrl: './elegir-paquete.component.html',
  styleUrls: ['./elegir-paquete.component.scss']
})
export class ElegirPaqueteComponent implements OnInit {
  environment = environment.BASE_URL
  
  data:any;
  dataUsuario:any;
  paquetes:any;

  respuestaGet:any;
  respuestaAgregar:any;
  respuestaDetallePaquete:any;

  detallePaquete:any;

  solicitado:any;
  clienteId:any;
  paqueteid:any;

  paqueteImagen:any;
  nombrePaquete:any;
  descripcion:any;

  avance = 0;
  dataAvance:any;

  molduras:any;
  colores:any;
  dedicatorias:any;
  placas:any;
  tokenActual:any;

  dedicatoriaPersonalizada;

  paquetesSeleccionados;
  placasSeleccionados;
  moldurasSeleccionados;
  coloresSeleccionados;
  viajesSeleccionados;
  fiestasSeleccionadas;
  anillosSeleccionados;
  descuentosAplicados;
  productosSeleccionados;
  dedicatoriasSeleccionadas;
  fondosMoldurasSeleccionados;

  respuestaPaqueteCliente:any;
  respuestaEliminar:any;
  paqueteCliente:any;

  total:any;

  contenido:any;
  pago:any;
  respuestaPago:any;

  constructor(private _get:ClientesService, private _paquetes:PaquetesService, 
    private _agregar: ClientesService, private modalService:NgbModal, 
    private iziToast:Ng2IzitoastService, private _getDedicatorias: ProductosService,
    private _getPaqueteCliente:ClientesService,
    private router:Router) { }

  ngOnInit(): void {
    if (!localStorage.getItem('token')) {// si no retorna un token se redirecciona al login
        this.router.navigate(['/']);
    }
    
    this.pago = {
      concepto:'',
      monto: '',
      nombre: '',
      apellidos: '',
    }

    this.getDataUsuario();
    this.getContenido();
    this.getPaquetes();
    // this.getMolduras();
    this.getMostSelectedMolduras();
    this.getColores();
    // this.getPlacas();
    this.getMostSelectedPlacas();
    this.getDedicatorias();

    this.dedicatoriaPersonalizada = {
      texto: '',
      dirigido:'',
    }

    this.dataUsuario = {
      usuario:'',
    }
  }

  getDataUsuario(){
    this._get.getDataUsuario().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.dataUsuario = this.respuestaGet.content;
          this.dataAvance = this.respuestaGet.avances;
          this.solicitado = this.respuestaGet.solicitado;
          this.clienteId = this.dataUsuario.id;

          // alert('solicitado:'+this.solicitado)
          // alert('el otro solicitado:'+this.dataAvance.solicitado  )
          if(this.dataUsuario.is_staff == true){
            this.router.navigate(['clientes']);
          }

          if(this.dataUsuario.solicitado == 1){
            this.router.navigate(['perfil']);
          }
          if(this.dataAvance.video == 0){
            this.avance = 999;
          }else if(this.dataAvance.paquete == 0){
            this.avance = 0;
          }else if (this.dataAvance.marco == 0){
            this.avance = 1;
          }else if (this.dataAvance.color == 0){
            this.avance = 2;
          }else if (this.dataAvance.placa == 0){
            this.avance = 3;
          }else if (this.dataAvance.dedicatoria == 0){
            this.avance = 4;
          }else if (this.dataAvance.solicitado == 0){
            // return;
            this.tokenActual = localStorage.getItem('token');
            this.tokenActual = this.tokenActual.replace('token ','');
            this.avance = 5;
            this.router.navigate(['/perfil/realizar-pago']);
            this.getPaqueteCliente(this.clienteId);
          }else{
            this.router.navigate(['perfil']);
          }
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPaquetes(){
    this._paquetes.getPaquetesClienteV2().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.paquetes = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getContenido(){
    this._paquetes.getContenido().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.contenido = this.respuestaGet.content[0];
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPaqueteCliente(cliente){
    this.data = {
      'cliente':cliente
    }

    this._getPaqueteCliente.getPaqueteCliente(this.data).subscribe(
      data => {
        this.respuestaPaqueteCliente = data;
        if(this.respuestaPaqueteCliente.success){
          this.paqueteCliente = this.respuestaPaqueteCliente.content;
          this.paquetesSeleccionados = this.paqueteCliente.paquetes;
          this.moldurasSeleccionados = this.paqueteCliente.molduras;
          this.coloresSeleccionados = this.paqueteCliente.colores;
          this.placasSeleccionados = this.paqueteCliente.placas;
          this.viajesSeleccionados = this.paqueteCliente.viajes;
          this.fiestasSeleccionadas = this.paqueteCliente.fiestas;
          this.anillosSeleccionados = this.paqueteCliente.anillos;
          this.descuentosAplicados = this.paqueteCliente.descuentos;
          this.productosSeleccionados = this.paqueteCliente.productos;
          this.dedicatoriasSeleccionadas = this.paqueteCliente.dedicatorias;
          this.fondosMoldurasSeleccionados = this.paqueteCliente.fondosMolduras;
          
          this.total = this.paqueteCliente.total;
          this.clienteId = cliente;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  getMolduras(){
    this._agregar.getMolduras().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.molduras = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getMostSelectedMolduras(){
    this._agregar.getMostSelectedMolduras().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.molduras = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getColores(){
    this._agregar.getColores().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.colores = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPlacas(){
    this._agregar.getPlacas().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.placas = this.respuestaGet.content;
          console.log(this.placas);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getMostSelectedPlacas(){
    this._agregar.getMostSelectedPlacas().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.placas = this.respuestaGet.content;
          console.log(this.placas);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getDedicatorias(){
    this._getDedicatorias.getDedicatorias().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.dedicatorias = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  agregarPaqueteCliente(paquete, cliente){
    this.data = {
      'paquete':paquete, 
      'cliente':cliente,
  }

    this._agregar.agregarPaqueteClienteV2(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success ==  '1'){
            this.iziToast.show(
              {
                  title: 'Se ha agregado el paquete correctamente.',
                  titleColor: '#f8f8ff',
                  color: '#4CAF50',
                  position: 'topRight',
                  closeOnEscape: true,
              });
            this.getDataUsuario();
            window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  getDetallePaquete(paquete){
    this.data = {
      'paquete':paquete
    }

    this._paquetes.getDetallePaquete(this.data).subscribe(
      data => {
        this.respuestaDetallePaquete = data;
        if(this.respuestaDetallePaquete.success){
          this.detallePaquete = this.respuestaDetallePaquete.content;
          this.paqueteid = paquete;
          this.nombrePaquete = this.detallePaquete[0].paquete;
          this.descripcion = this.detallePaquete[0].descripcion;
          if (this.detallePaquete[0].imagen.length == 0){
            this.paqueteImagen = '/uploads/paquete/auri.png';
          }else{
            this.paqueteImagen = this.detallePaquete[0].imagen;
          }
          document.getElementById('clickPaquete').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarMoldura(moldura, cliente){
    this.data = {
        'moldura':moldura, 
        'usuario':cliente
    }

    this._agregar.agregarMolduraUsuarioV2(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success ==  '1'){
          this.iziToast.show(
            {
                title: 'Se ha elegido correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getDataUsuario();
      }else {
        alert('No se cargaron los datos');
      }
      }, error => console.error(error)
    )
  }

  agregarColor(color, cliente){
    this.data = {
      'color':color, 
      'cliente':cliente
  }

    this._agregar.agregarColorUsuarioV2(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success ==  '1'){
          this.iziToast.show(
            {
                title: 'Se ha elegido correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getDataUsuario();
      }else {
        alert('No se cargaron los datos');
      }
      }, error => console.error(error)
    )
  }

  agregarPlaca(placa, cliente){
    this.data = {
        'placa':placa, 
        'usuario':cliente
    }

    this._agregar.agregarPlacaUsuarioV2(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success ==  '1'){
          this.iziToast.show(
            {
                title: 'Se ha elegido correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getDataUsuario();
      }else {
        alert('No se cargaron los datos');
      }
      }, error => console.error(error)
    )
  }

  agregarDedicatoriaCliente(nombre, texto, dirigido, cliente){

    if(dirigido == ''){
      this.iziToast.show(
        {
            title: 'Por favor indica a quién va dirigida la dedicatoria',
            titleColor: '#f8f8ff',
            color: '#CA0B00',
            position: 'topRight',
            closeOnEscape: true,
        });
        return;
    }

    this.data = {
        'nombre':nombre, 
        'texto':texto, 
        'dirigido':dirigido, 
        'cliente':cliente
    }

    this._agregar.agregarDedicatoriaClienteV2(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success ==  '1'){
          this.iziToast.show(
            {
                title: 'Se ha elegido correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getDataUsuario();
      }else {
        alert('No se cargaron los datos');
      }
      }, error => console.error(error)
    )
  }

  eliminarPaqueteRegistrarme(paquete, cliente){
    this.data = {
      'paquete':paquete,
      'usuario':cliente,
    }

    this._getPaqueteCliente.eliminarPaqueteRegistrarme(this.data).subscribe(
      data => {
        this.respuestaEliminar = data;
        if(this.respuestaEliminar.success){
          this.iziToast.show(
            {
                title: 'Se ha eliminado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarPlacaRegistrarme(placa, cliente){
    this.data = {
      'placa':placa,
      'usuario':cliente,
    }

    this._getPaqueteCliente.eliminarPlacaRegistrarme(this.data).subscribe(
      data => {
        this.respuestaEliminar = data;
        if(this.respuestaEliminar.success){
          this.iziToast.show(
            {
                title: 'Se ha eliminado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarMarcoRegistrarme(marco, cliente){
    this.data = {
      'marco':marco,
      'usuario':cliente,
    }

    this._getPaqueteCliente.eliminarMarcoRegistrarme(this.data).subscribe(
      data => {
        this.respuestaEliminar = data;
        if(this.respuestaEliminar.success){
          this.iziToast.show(
            {
                title: 'Se ha eliminado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarColorRegistrarme(color, cliente){
    this.data = {
      'color':color,
      'usuario':cliente,
    }

    this._getPaqueteCliente.eliminarColorRegistrarme(this.data).subscribe(
      data => {
        this.respuestaEliminar = data;
        if(this.respuestaEliminar.success){
          this.iziToast.show(
            {
                title: 'Se ha eliminado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarDedicatoriaRegistrarme(dedicatoria, cliente){
    this.data = {
      'dedicatoria':dedicatoria,
      'usuario':cliente,
    }

    this._getPaqueteCliente.eliminarDedicatoriaRegistrarme(this.data).subscribe(
      data => {
        this.respuestaEliminar = data;
        if(this.respuestaEliminar.success){
          this.iziToast.show(
            {
                title: 'Se ha eliminado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  solicitarPaqueteRegistrarme(cliente){
    this.data = {
      'usuario':cliente
  }

  this._agregar.solicitarPaqueteRegistrarme(this.data).subscribe(
    data => {
      this.respuestaAgregar = data;
      if(this.respuestaAgregar.success ==  '1'){
        this.iziToast.show(
          {
              title: 'Se ha solicitado correctamente.',
              titleColor: '#f8f8ff',
              color: '#4CAF50',
              position: 'topRight',
              closeOnEscape: true,
          });
        window.location.reload();
    }else {
      alert('No se cargaron los datos');
    }
    }, error => console.error(error)
  )

  }

  omitirDedicatoria(cliente){
    this.data = {
      'cliente': cliente,
    }
    
    this._agregar.omitirDedicatoria(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success ==  '1'){
          this.iziToast.show(
            {
                title: 'Se ha elegido correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getDataUsuario();
      }else {
        alert('No se cargaron los datos');
      }
      }, error => console.error(error)
    )
  }


  // validStripe(stripeToken: string): void {
  //   this.pago.tokenStripe = stripeToken;
  //   if (this.pago.monto > 0){
  //     if(this.pago.concepto != ''){
  //       this._agregar.enviarPago(this.pago).subscribe(
  //         data => {
  //           this.respuestaPago = data;
  //           if(this.respuestaPago.success == 1){
  //             this.iziToast.show(
  //               {
  //                   title: 'Se ha realizado el pago correctamente.',
  //                   titleColor: '#f8f8ff',
  //                   color: '#4CAF50',
  //                   position: 'topRight',
  //                   closeOnEscape: true,
  //               });
  //               this.pago.monto = '';
  //               this.pago.concepto = '';
  //               this.pago.nombre = '';
  //               this.pago.apellidos = '';

  //           }else {
  //             this.iziToast.show(
  //               {
  //                   title: 'No pudimos procesar tu pago',
  //                   titleColor: '#f8f8ff',
  //                   color: '#4CAF50',
  //                   position: 'topRight',
  //                   closeOnEscape: true,
  //               });
  //               this.pago.monto = '';
  //               this.pago.concepto = '';
  //           }
  //         }, error => console.error(error));
  //     }else{
  //       this.iziToast.show(
  //         {
  //             title: 'Por favor ingresa el concepto de tu pago',
  //             titleColor: '#FFF',
  //             color: '#31325F',
  //             position: 'topRight',
  //             closeOnEscape: true,
  //         });
  //     }

      
  //   }else{
  //     this.iziToast.show(
  //       {
  //           title: 'Por favor ingresa el monto de tu pago',
  //           titleColor: '#FFF',
  //           color: '#31325F',
  //           position: 'topRight',
  //           closeOnEscape: true,
  //       });
  //   }
  // }


  actualizarAvanceVideo(cliente){
    this.data = {
      'cliente': cliente,
    }
    
    this._agregar.actualizarAvanceVideo().subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success ==  '1'){
          this.getDataUsuario();
          window.location.reload();
      }else {
        alert('No se cargaron los datos');
      }
      }, error => console.error(error)
    )
  }


  async closeSesion() {
    await localStorage.removeItem('token');
    await this.router.navigate(['']);
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
